import React, { useEffect, useState } from "react";
import styled from "styled-components";
import emailjs from "emailjs-com";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { FaRegLaughWink } from "react-icons/fa";

const Contactus1 = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [snackbarInfo, setSnackbarInfo] = useState({
    message: "",
    severity: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      from_name: name,
      from_phone: phone,
      from_email: email,
      message,
    };
      //service id, template id, template parameter,public key
    emailjs
      .send(
      
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (response) => {
          // console.log("SUCCESS!", response.status, response.text);
          setSnackbarInfo({
            message: "Message sent successfully!",
            severity: "success",
          });
          setOpen(true);
          setName("");
          setPhone("");
          setEmail("");
          setMessage("");
        },
        (err) => {
          // console.error("FAILED...", err);
          setSnackbarInfo({
            message: "Failed to send your message. Please try again.",
            severity: "error",
          });
          setOpen(true);
        }
      );
  };

 

  return (
    <Wrapper id="contact">
      <h2 className="container common-heading">Contact Us</h2>
      <p className="common-text">
        Reach out and let's fuel your journey together!
      </p>
      <div className="container">
        <div className="left">
          
         
          <iframe
           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7776.761396371018!2d74.81695884210356!3d12.947474041082264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba351b77272ce21%3A0xdecca78598f81922!2sM%20Shine%20Enterprises.%20(DEF)(adblue)!5e0!3m2!1sen!2sin!4v1726900154922!5m2!1sen!2sin"
          width="100%"
            height="400"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="mshine"
          ></iframe>
        </div>
        <div className="right">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="name mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="phone mb-3">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter your Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="email mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="textarea mb-3">
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter your message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarInfo.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarInfo.message}
        </Alert>
      </Snackbar>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  text-align: center;
  padding-top: 5px;
  padding-bottom: 10px;

  .common-heading {
    text-transform: uppercase;
    font-size: 2rem;
    font-family: "Play", sans-serif;
    font-weight: 900;
    font-style: italic;
    color: white;
    padding: 10px;
   
    font-size: 45px;
    background-color:  #2363e7;
  }

  .common-text {
    text-align: center;
    font-family: "Play";
    text-transform: uppercase;
    font-size: 1.2rem;
    margin-top: 20px;
  }

  .container {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
  }

  .left,
  .right {
    flex: 1;
    height: 400px;
    max-width: 48%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;

    /* &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 9px rgba(35, 85, 241, 0.48);
    } */
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(204, 204, 204, 0.2);
    backdrop-filter: blur(10px);
    height: 400px; /* Ensures the form height matches the map height */
    padding: 20px; /* Adds padding to the right container */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .form-group {
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 300px;
    justify-content: center; /* Centers the content vertically */
  }

  .name,
  .email,
  .phone,
  .textarea {
    width: 100%;
  }

  .form-control {
    border-radius: 1.4rem;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    width: 300px;
    border-radius: 5px;
    margin-bottom: 1rem;
  }

  .btn {
    max-width: 12rem;
    text-align: center;
    text-decoration: none;
    /* padding: 0.8rem 1.2rem; */
    border-radius: 50px;
    width: 140px;
    background-color: #2363e7;
    outline: 2px solid #2363e7;
    outline-offset: 2px;
    color: white;

    font-size: 0.9;
    font-weight: 500;
    /* font-style: italic; */
    text-transform: uppercase;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease;
  }

  .btn:hover {
    background-color: rgb(255, 191, 0);
    outline: 2px solid rgb(255, 191, 0);
    /* transform: translateX(1px); */
    font-weight: 700;
    color: white;
  }

  @media (max-width: 768px) {
    .common-heading {
      font-size: 32px;
    }

    .container {
      flex-direction: column;
      align-items: center;
    }

    .left,
    .right {
      max-width: 100%;
    }

    .form-group {
      width: 100%;
      height: auto; /* Ensure responsive height for smaller screens */
    }

    .right {
      height: auto; /* Ensure responsive height for smaller screens */
    }
  }
`;

export default Contactus1;
